import React, { useState, useEffect } from "react";
import styles from "../../../styles/components/softskill.module.scss";
import Icons from "../../../public/assets/svg";
import BasicForm from "../../basicForm";
import { useRouter } from "next/router";
import axios from "axios";
import Loader from "../../Loader";
import _get from "lodash/get";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UploadFile from "../../uploadFileemptwin";
import endpoints from "../../../utility/endpoints";
import SuccessModal from "../../../pages/successModal";
import { BlobServiceClient } from "@azure/storage-blob";
import UploadDoc from "../../DocumentsoftskillUploader";
const ModalExample = (props) => {
  // console.log("Props soft skill ---", props);
// console.log(props.softidfrommodal);
  const sucessFailure =
  props.data[1].component.content.field_message_type_value_pair;
  const modalRef = React.useRef(null);

  // method to close the modal if clicked outside
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          //props.closeModal();
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(modalRef);

  const router = useRouter();
  
  const initialState = {
    "employeeTwinID": props.empid,
    "softSkillID": "",
    "skillName": "",
    "skillDescription": "",
    "status": "",
    "Profile": "",
    "engagementLeadEmail": "",
    "businessRequestorEmail": "",
    "sopDocument":"",	
    "pddDocument":"",	
    "pddApprovalDocument":"",	
    "sddDocument":"",	
    "qsgDocument":"",	
    "odiDocument":"",	
    "brdDocument":"",	
    "costApprovalDocument":"",	
    "explicitLandscapeApplicationOwnerApprovalDocument":"",	
    "explicitGPMApprovalSupplyChainFinanceDocument": "",	
    "explicitGFCFApprovalDocument": "",	
    "devQualityCredentialsAvailableDocument": "",	
    "infosecApprovalDocument": "",	
    "dAReviewSignOffDocument": "",	
    "testDataAvailableForDevelopmentDocument": "",	
    "requestRaisedForProductionCredentialsDocument": "",	
    "internalTestingCompletedDocument": "",	
    "peerReviewSignOffDocument": "",	
    "daReviewSecondSignOffDocument": "",	
    "bpReleaseSignOffFromDaDocument": "",	
    "uatScriptsWithResultsDocument": "",	
    "uatSignOffDocument": "",	
    "releaseManagerSignOffDocument": "",	
    "gateFormDocument": "",	
    "peerReviewchecklistDocument": "",	
    "qaSignOffDocument": "",	
    "walkthroughVideo": "",	
    "ktVideo": "",
  };
  const rawErrorData = {
    skillName: false,
    status: false,
    Profile: false,
    engagementLeadEmail: false,
    businessRequestorEmail: false,
    uploadDocument: false,
    sopDocument:false,	
    pddDocument:false,	
    pddApprovalDocument: false,	
    sddDocument: false,	
    qsgDocument: false,	
    odiDocument: false,	
    brdDocument: false,	
    costApprovalDocument: false,	
    explicitLandscapeApplicationOwnerApprovalDocument: false,	
    explicitGPMApprovalSupplyChainFinanceDocument: false,	
    explicitGFCFApprovalDocument: false,	
    devQualityCredentialsAvailableDocument: false,	
    infosecApprovalDocument: false,	
    dAReviewSignOffDocument: false,	
    testDataAvailableForDevelopmentDocument: false,	
    requestRaisedForProductionCredentialsDocument: false,	
    internalTestingCompletedDocument: false,	
    peerReviewSignOffDocument: false,	
    daReviewSecondSignOffDocument: false,	
    bpReleaseSignOffFromDaDocument: false,	
    uatScriptsWithResultsDocument: false,	
    uatSignOffDocument: false,	
    releaseManagerSignOffDocument: false,	
    gateFormDocument: false,	
    peerReviewchecklistDocument: false,	
    qaSignOffDocument: false,	
    walkthroughVideo: false,
    ktVideo: false
}
 const [modalShow, setModalShow] = React.useState(false);

  const [state, setState] = React.useState(initialState);
  const [stateError, setStateError] = useState(rawErrorData);
  const [items, setItems] = useState([]);
  const [sskillid,setSskillid]=React.useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [Loading, setLoading] = React.useState(false);
  /*Upload file code */
 
 

  const [fileError, setError] = useState(false);

  const [file, setFile] = useState(null);
  const [fileNameOriginal, setFileName] = useState(null);

  const [showFileName, setShowFileName] = useState(false);
  const [automationPdfs, setAutomationPdfs] = useState([]);
  const [confidentialPdfs, setConfidentialPdfs] = useState([]);
  const [auth, setAuth] = useState({});
  const [filenameError, setFileNameError] = useState(false);
   const [uploadedDocumentsState, setUploadedDocumentsState] = React.useState(null);	
  const [totalUploadedItems, setTotalUploadedItems] = React.useState(null);
  const [fileTypes, setfileTypes] = useState([
    "pdf",
    "docx",
    "doc",
    "xlsx",
    "msg",
    "jpg",
    "jpeg",
    "png",
    "ppt",
    "pptx",
  ]);
  const [docfolder,setDocfolder]=("");
/*Dropdown Added by Anshu*/
  const requestDemoInfo = props.data[0].component.content;
  const {
    field_title,
    field_message_input,
    field_options,
    field_request_demo_form_componen,
  } = requestDemoInfo;



  const formComponents = field_request_demo_form_componen.filter(
    (item) => item.field_label != "Remarks"
  );

  const remarkComponent=props.data[0].component.content.field_request_demo_form_componen[0];
  const requesttype=props.data[0].component.content.field_request_demo_form_componen[1];
  const softskillid=props.data[0].component.content.field_request_demo_form_componen[2];
  const softskillname=props.data[0].component.content.field_request_demo_form_componen[3];
  const status=props.data[0].component.content.field_request_demo_form_componen[4];
  const profile=props.data[0].component.content.field_request_demo_form_componen[5];
  const engagementlead=props.data[0].component.content.field_request_demo_form_componen[6];
  const businessrequestor=props.data[0].component.content.field_request_demo_form_componen[7];
  const uploadDocument=props.data[0].component.content.field_request_demo_form_componen[8];
  const category=props.data[0].component.content.field_request_demo_form_componen[9];
  const softskillForm = () => {
    setGetFormValues(true);
  };
 	const gotDocInfo = (name, url, title, uploadedItems, extension) => {	
    let ar = url.split("?");	
    let another = ar[0].split("/");	
    let toSend = another[another.length - 1];	
    // console.log(title, uploadedItems, "uploaded data of data");	
    // console.log(name, "nameat uploaderrr", title)	
    console.log(extension, "extension at 56")	
  //  setUploadedFileToShow(title);	
    setTotalUploadedItems(uploadedItems);	
    sendDocInfo(name, toSend, extension);	
  };
    const [sopInvalid, setSopInvalid] = React.useState(false);

 	const sendAllInfoAboutUploadModal = (	
    uploaded,	
    totalItems,	
    uploadedItems,	
    originalFileNames,	
    azureFileNames,	
    deleteDocumentsLater,	
    presentState	
  ) => {	
    if (uploaded.sopDocument) {	
      setSopInvalid(false)	
    }	
    else {	
      setSopInvalid(true)	
    }	
    console.log("sab console kara lo",  uploaded,"1",	
    totalItems,"22",	
    uploadedItems, "33",	
    originalFileNames,"44",	
    azureFileNames,"555",	
    deleteDocumentsLater,"6666",	
    presentState)	
   	
   //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)	
   console.log(azureFileNames, "azurefiles234latest")	
   console.log(uploadedDocumentsState, "azurefiles234previous")	
   let deleteDocumentsLaterToSet = []	
   if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length>0){	
     deleteDocumentsLaterToSet = [...uploadedDocumentsState.deleteDocumentsLater]	
     for (let i in uploadedDocumentsState.azureFileNames) {	
      if (!(i in azureFileNames)){	
        deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i])	
      }	
    }	
   }	
  	
  	
    setUploadedDocumentsState({	
      uploaded,	
      totalItems,	
      uploadedItems,	
      originalFileNames,	
      azureFileNames : {...azureFileNames},	
      deleteDocumentsLater : [...deleteDocumentsLaterToSet],	
    });	
    setTotalUploadedItems(uploadedItems)	
    {/*props.saveUploadDocumentStateInRedux({	
      uploaded,	
      totalItems,	
      uploadedItems,	
      originalFileNames,	
      azureFileNames : {...azureFileNames},	
      deleteDocumentsLater : [...deleteDocumentsLaterToSet],	
      	
    }, presentState);*/}	
  };	
const openDocumentModal = () => {	
    let modal = !modalShow;	
    setModalShow(true);	
    if (modal === true) {	
      document.body.style.overflow = "hidden";	
    } else {	
      document.body.style.overflow = "unset";	
    }	
  };	
  const closeDocumentModal = () => {	
    let modal = !modalShow;	
    setModalShow(false);	
    if (modal === true) {	
      document.body.style.overflow = "hidden";	
    } else {	
      document.body.style.overflow = "unset";	
    }	
  };
  let azurefilepath;
  const blobSasUrl =
  "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";

const blobSasUrlNew = endpoints.blobSasUrlNew;
// "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

const containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin");

  const uploadFile = (file, name) => {
    //console.log(file.name, "pdfsauto");
    azurefilepath= "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/"+file.name;
    //console.log("azure file path",azurefilepath)
    //console.log(automationPdfs, "pdfsauto");
    if (
      automationPdfs.filter((item, index) => item.docUrl == file.name).length >
        0 ||
      confidentialPdfs.filter((item, index) => item.docUrl == file.name)
        .length > 0
    ) {
      setFileNameError(true);
      setSuccessModal(true);
      return;
    }

    setFile(file);
    setShowFileName(true);
    setFileName(file.name);

  };

  const uploadButtonClick = async () => {
    //console.log(fileNameOriginal, "fileName", file);

    let fileNameWithSpaces = fileNameOriginal;
    let fileName = fileNameWithSpaces.replace(/ /g, " ");
   let ar = fileNameOriginal.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file.size;

    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;

      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/framework/createFramework`,
          data: {
            docType: extension,
            docName: fileNameOriginal,
            docCategory: "png",
            docUrl: toSend,
            docSize: fileSize,
          },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((resp) => {
          if (resp.data.code == 200) {
            //  console.log(resp);
            window.scrollTo(0, 0);
            setSuccessModal(true);
            //setShowFileName(false);
            //setLoader(false);
           // setFile(null);
            setError(false);
            //setFileName(null);
            //getAllPdfs();
          } else if (resp.data.code == 403) {
            //setLoader(false);
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
        });
      } else {
        //setLoader(false)
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log(error, "erro");
      alert("Could not upload");
    }
  };
  
  const onValueChange = async (e) => {
    const value = e.target.value;
    
      if((e.target.id=="engagementLeadEmail" ) && !validateEmail(e.target.value))
      {
        
      }
      else if(e.target.id=="businessRequestorEmail" && !validateEmail(e.target.value))
      {
        
      }
      else
      {
      setState({
        ...state,
        [e.target.id]: value,
      });
    
   
  }
    
    if (e.target.value ) {
      setStateError({ ...stateError, [e.target.id]: "valid" });
    } 
    else {
      setStateError({ ...stateError, [e.target.id]: true });
    }

}
// localStorage.setItem("item" , JSON.stringify(soft_skill_arr))
// localStorage.setItem("abc" , JSON.stringify(items))
let soft_skill_arr =[];
function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(String(email).toLowerCase())) {
    let emailAr = email.split("@");
    if (emailAr.length == 2) {
      if (emailAr[1] == "unilever.com") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  // return re.test(String(email).toLowerCase());
}
const [softdocument,setSoftdocument]=useState(false);
  const onFromSubmit = async () => {

      setSubmitForm(true);
      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      let moveAhead = true;
       let softdocs=JSON.parse(localStorage.getItem("docURL"));	
{/*       if(!(localStorage.getItem("docURL"))){	
        setSoftdocument(true);	
       }*/}	
  if(localStorage.getItem("docURL")){	
        setSoftdocument(false);	
       }
        if(!(softdocs?.sopDocument)){
        setSoftdocument(true);
       }
             let sopDocument=softdocs?.sopDocument || '';	
      let pddDocument=softdocs?.pddDocument || '';	
      let pddApprovalDocument= softdocs?.pddApprovalDocument || '';	
      let sddDocument= softdocs?.sddDocument || '';	
      let qsgDocument= softdocs?.qsgDocument || '';	
      let odiDocument= softdocs?.odiDocument || '';	
      let brdDocument= softdocs?.brdDocument || '';	
      let costApprovalDocument= softdocs?.costApprovalDocument || '';	
      let explicitLandscapeApplicationOwnerApprovalDocument= softdocs?.explicitLandscapeApplicationOwnerApprovalDocument || '';	
      let explicitGPMApprovalSupplyChainFinanceDocument= softdocs?.explicitGPMApprovalSupplyChainFinanceDocument || '';	
      let explicitGFCFApprovalDocument= softdocs?.explicitGFCFApprovalDocument || '';	
      let devQualityCredentialsAvailableDocument= softdocs?.devQualityCredentialsAvailableDocument || '';	
      let infosecApprovalDocument= softdocs?.infosecApprovalDocument || '';	
      let dAReviewSignOffDocument= softdocs?.dAReviewSignOffDocument || '';	
      let testDataAvailableForDevelopmentDocument= softdocs?.testDataAvailableForDevelopmentDocument || '';	
      let requestRaisedForProductionCredentialsDocument= softdocs?.requestRaisedForProductionCredentialsDocument || '';	
      let internalTestingCompletedDocument= softdocs?.internalTestingCompletedDocument || '';	
      let peerReviewSignOffDocument= softdocs?.peerReviewSignOffDocument || '';	
      let daReviewSecondSignOffDocument= softdocs?.daReviewSecondSignOffDocument || '';	
      let bpReleaseSignOffFromDaDocument= softdocs?.bpReleaseSignOffFromDaDocument || '';	
      let uatScriptsWithResultsDocument= softdocs?.uatScriptsWithResultsDocument || '';	
      let uatSignOffDocument= softdocs?.uatSignOffDocument || '';	
      let releaseManagerSignOffDocument= softdocs?.releaseManagerSignOffDocument || '';	
      let gateFormDocument= softdocs?.gateFormDocument || '';	
      let peerReviewchecklistDocument= softdocs?.peerReviewchecklistDocument || '';	
      let qaSignOffDocument= softdocs?.qaSignOffDocument || '';	
      let walkthroughVideo= softdocs?.walkthroughVideo || '';	
      let ktVideo= softdocs?.ktVideo || '';
      if(state.skillName==""||state.status==""||state.Profile==""||state.engagementLeadEmail == "" || state.businessRequestorEmail=="" || softdocument){
       
      }

       else{
          if (expiryStatus) {
            let auth = await JSON.parse(localStorage.getItem("auth")).data;
            axios({
              method: "post",
              url: `${endpoints.baseUrl}/softSkill/add`,
              headers: {
                Authorization: `${auth.accessToken}|${auth.email}`,
              },
              data: {
                ...state,
                	                sopDocument:sopDocument,	
                pddDocument:pddDocument,	
                pddApprovalDocument: pddApprovalDocument,	
                sddDocument: sddDocument,	
                qsgDocument: qsgDocument,	
                odiDocument: odiDocument,	
                brdDocument: brdDocument,	
                costApprovalDocument: costApprovalDocument,	
                explicitLandscapeApplicationOwnerApprovalDocument: explicitLandscapeApplicationOwnerApprovalDocument,	
                explicitGPMApprovalSupplyChainFinanceDocument: explicitGPMApprovalSupplyChainFinanceDocument,	
                explicitGFCFApprovalDocument: explicitGFCFApprovalDocument,	
                devQualityCredentialsAvailableDocument: devQualityCredentialsAvailableDocument,	
                infosecApprovalDocument: infosecApprovalDocument,	
                dAReviewSignOffDocument: dAReviewSignOffDocument,	
                testDataAvailableForDevelopmentDocument: testDataAvailableForDevelopmentDocument,	
                requestRaisedForProductionCredentialsDocument: requestRaisedForProductionCredentialsDocument,	
                internalTestingCompletedDocument: internalTestingCompletedDocument,	
                peerReviewSignOffDocument: peerReviewSignOffDocument,	
                daReviewSecondSignOffDocument: daReviewSecondSignOffDocument,	
                bpReleaseSignOffFromDaDocument: bpReleaseSignOffFromDaDocument,	
                uatScriptsWithResultsDocument: uatScriptsWithResultsDocument,	
                uatSignOffDocument: uatSignOffDocument,	
                releaseManagerSignOffDocument: releaseManagerSignOffDocument,	
                gateFormDocument: gateFormDocument,	
                peerReviewchecklistDocument: peerReviewchecklistDocument,	
                qaSignOffDocument: qaSignOffDocument,	
                walkthroughVideo: walkthroughVideo,	
                ktVideo: ktVideo,
                uploadDocument:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/"+fileNameOriginal
              },
            }).then((resp) => {
              if (resp.data.code == 403) {
                setLoading(false)
                localStorage.removeItem("auth");
                props.sessionTimeOutCheck(true);
                setEmptyFormValues(!emptyFormValues);
                setState(initialState);
                setGetFormValues(false);
              } 
              else if (resp.status == 200) {
                setEmptyFormValues(!emptyFormValues);
                // console.log(resp.data);
                // console.log("data from api---->",resp.data.data.softSkillID)
                
                setItems(resp.data.data.softSkillID)
                if(JSON.parse(localStorage.getItem('myData')))
                {
                  let storedData = JSON.parse(localStorage.getItem('myData'));
                  // console.log(storedData);
                  storedData.push(resp.data.data.softSkillID);
                  localStorage.setItem('myData', JSON.stringify(storedData));
                }
                else
                {
                  localStorage.setItem('myData', JSON.stringify([resp.data.data.softSkillID]));
                }
                
                setState(initialState);
                setGetFormValues(false);
                props.closeModal();
                props.setSuccessModal(true);
                props.setMessage(sucessFailure[0].field_message+` and the soft skill id is ${resp.data.data.softSkillID}`);
                setLoading(true);
                if(props.name=="empskillpage"){
                props.softidfrommodal(resp.data.data.softSkillID);
                }
                props.setSuccessModal(true);
              } 
              else if (resp.data.code == 400) {
                setEmptyFormValues(!emptyFormValues);
                setLoading(false);
                setState(initialState);
                setGetFormValues(false);
              // props.setMessage(sucessFailure[1].field_message[0]);
                props.setsucessOrFailure(true);
                props.closeModal();
                props.setSuccessModal(true);
              }
            });
          } else {
            setLoading(false)
            props.sessionTimeOutCheck(true);
            
          }
        }
    
  };

  const handledemo = () => {
    props.closeModal();
    document.body.style.overflow = "unset";
  };
  // console.log("iteam_check------>" , items)
  // document upload code by Anshu
 
 
  return (
    <div className={styles.editModalWrapper}>
      {Loading ? (
        <Loader />
      ) : (
        <div className={styles.modalBox} ref={modalRef}>
        <div className={`${styles.formContainer}`}>
          <div className="container">
          
            <div className="row">
              <div class="col-md-12">
              <span
                className={styles.rowBtn}
                onClick={() => {
                  handledemo();
                }}
              >
                <div className={styles.icon}>
                    <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png" className={styles.iconimg}/>
                </div>
              </span>
              </div>
              <div className="col-md-12">
                <h2 className={styles.head}>{field_title} </h2>
              </div>
              <div className="col-md-12">
                <p className={styles.text}>{field_message_input}
                </p>
              </div>
            </div>
            </div>
          </div>
         
          <div className={styles.modalBody}>
            
            {/* <div className={styles.detailsSec}> */}
            <div className={styles.row}>
              {/* <BasicForm
                data={formComponents}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                setGetFormValues={setGetFormValues}
              /> */}
            </div>
            <div className={styles.row}>
              <div className="col-lg-12 col-md-12 col-12">
                <div className={styles.formGroup}>
                  
                  <div className={styles.formheading}>
                  <p> <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/softskillvector.png"/><span>Soft Skill Form</span></p>
                  </div>
                </div>
              </div>
             
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      softskillname,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {submitForm?
                    (state.skillName == "" && state.skillName.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        softskillname,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  id="skillName"
                  name="skillName"
                  onChange={onValueChange}
                />
              </div>
              </div>
              <div className="col-lg-12 col-md-12 col-12">
                <div className={styles.formGroup}>
                  <div className={styles.labelstyle}>
                    <label>
                    {_get(
                      remarkComponent,
                      "field_form_field_title",
                      ""
                    )}
                   
                    {/* {invalidFlag ? (
                      <span className={styles.errorMessage}>
                        {_.get(
                          remarkComponent[0],
                          "field_message_ip_error_message",
                          ""
                        )}
                      </span>
                    ) : null} */}
                    </label>
                  </div>

                  <textarea
                    // className={`${invalidFlag ? styles.errorBorder : null}`}
                    placeholder={remarkComponent.field_title}
                    id="skillDescription"
                    name="skillDescription"
                    onChange={onValueChange}
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      status,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                  
                    {submitForm?
                    (state.status == "" && state.status.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        status,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                  </label>
                </div>

              
             
                <select className={styles.select} onChange={onValueChange}  name="status" id="status">
                  <option defaultValue> {_get(
                    status,
                      "field_form_field_title",
                      ""
                    )}</option>
                  {_get(
                    status,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>{item}</option>
                    )
                  })
                  }
                </select>
               
             
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      category,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                  
                    {submitForm?
                    (state.category == "" && state.category.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        category,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                  </label>
                </div>

              
             
                <select className={styles.select} onChange={onValueChange}  name="category" id="category">
                  <option defaultValue> {_get(
                    category,
                      "field_form_field_title",
                      ""
                    )}</option>
                  {_get(
                    category,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>{item}</option>
                    )
                  })
                  }
                </select>
               
             
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      profile,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                  
                    {submitForm?
                    (state.Profile == "" && state.Profile.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        profile,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  id="Profile"
                  name="Profile"
                  onChange={onValueChange}
                />
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      engagementlead,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                
                    {submitForm?
                    (state.engagementLeadEmail == "" && state.engagementLeadEmail.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        engagementlead,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) :null:null
                  }
                  </label>
                </div>
  <select className={styles.select} onChange={onValueChange}  name="engagementLeadEmail" id="engagementLeadEmail">
                  <option defaultValue> {_get(
                    engagementlead,
                      "field_form_field_title",
                      ""
                    )}</option>
                  {_get(
                    engagementlead,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>{item}</option>
                    )
                  })
                  }
                </select>
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      businessrequestor,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                 
                  {submitForm?
                    (state.businessRequestorEmail == "" && state.businessRequestorEmail.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        businessrequestor,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ):null:null
                  
                  }
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  id="businessRequestorEmail"
                  name="businessRequestorEmail"
                  onChange={onValueChange}
                />
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
              
                <div className={`${styles.uploadBtnWrapper}`}>
                  <div className={styles.uploadFileContainer}>
                  <label className={styles.mainLabel}>
                    {_get(
                      uploadDocument,
                      "field_title",
                      ""
                    )+'s'}
                    <sup className={styles.mandatoryField}>*</sup>
                    	                    	
                  {submitForm?	
                    (softdocument?(	
                    <span className={styles.errorMessage}>	
                    Please upload SOP Document	
                    </span>	
                  ):null):null	
                  	
                             }    
                  </label>
                  <div className={styles.uploadControl}>

                {/*<UploadFile
                  type="framework"
                  fileType={fileTypes}
                  uploadFile={uploadFile}
                  uploaded={showFileName}
                  value="frameworkDocument"
                />*/}
 	
		<div className={styles.multiDocsWrapper}>	
            <span className={styles.skillMultiDocs} 	
            onClick={openDocumentModal}	
            >	
              Open Document Uploader	
            </span>	
            <span className={styles.text}>	
              {/* {props.sopInvalid ? ( */}	
                {/*<span className={styles.errorMessage}>	
                  Please upload SOP Document	
                </span>*/}	
              {/* ) : 	
                totalUploadedItems != null &&	
                totalUploadedItems !== 0 ? (	
                `${"SOP document"} ${totalUploadedItems == 1	
                  ? ""	
                  : `+ ${totalUploadedItems - 1} file${totalUploadedItems-1 == 1 ? "" : "s"}`	
                } uploaded`	
              ) : (	
                `Files not uploaded`	
              )} */}	
            </span>	
          </div>
               

{/*
              <div className={styles.actionBtn} onClick={uploadButtonClick}>
                <span>
                  <Icons
                    name="uploadicon"
                    className={styles.uploadIcon}
                  ></Icons>
                 Upload File
                </span>
              </div>
*/}
            </div>
                    
                  </div>
                </div>
              </div>
            </div>
            </div>
            {/* </div> */}
          </div>
          <div className={styles.modalFooter}>
            <div className={styles.combinedBtn}>
           
              <span
                className={styles.exportListBtn}
                onClick={onFromSubmit}
              >
                {field_options[0]}
              </span>
            </div>
          </div>
        </div>
      )}
      
      {successModal ? (
          <SuccessModal
            setSuccessModal={() => {
              setSuccessModal(false);
              setFileNameError(false);
            }}
            title={"Framework"}
            message={
              filenameError
                ? "Document with this name already exists."
                : "uploaded"
            }
            fail={filenameError ? true : false}
          />
        ) : null}
       		<div className={styles.uploadContainer}>	
          {modalShow == true ? (	
            <UploadDoc	
              closeModal={closeDocumentModal}	
              sendDocInfo={gotDocInfo}	
              sendAllInfoAboutUploadModal={sendAllInfoAboutUploadModal}	
              uploadedDocumentsState={uploadedDocumentsState}	
              formType={fileTypes}	
              documentFolderName = "employeetwin"	
   	      softSkillDoc='softSkillDocState'         	
  	    />	
          ) : null}	
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);


